import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";

import spaapi from "@/shared/api/spa";
import sessionapi from "@/shared/api/session";

export const store = createStore({
  plugins: [
    createPersistedState({
      key: "vuex-spa",
    }),
  ],
  state: {
    session: null,
    search: null,

    availability: null,
    facilities: null,
    configuration: null,
    activities: null,
    extras: null,
  },
  getters: {
    session(state) {
      return state.session;
    },
    search(state) {
      return state.search;
    },
    configuration(state) {
      return state.configuration;
    },
    availability(state) {
      return state.availability;
    },
    facilities(state) {
      return state.facilities;
    },
    dayExtrasAvailability(state) {
      if (state.configuration != null) {
        let result = [];
        let extras = state.search.spaDay.Extras;

        for (let ei = 0; ei < extras.length; ei++) {
          let extra = extras[ei];

          let extraItem = {
            content: extra,
          };

          result.push(extraItem);
        }

        return result;
      }

      return null;
    },
    treatmentExtrasAvailability(state) {
      if (state.configuration != null) {
        let result = [];
        let extras = state.configuration.SpaTreatments.Extras;

        for (let ei = 0; ei < extras.length; ei++) {
          let extra = extras[ei];

          let extraItem = {
            content: extra,
          };

          result.push(extraItem);
        }

        return result;
      }

      return null;
    },
    booking(state) {
      return state.booking;
    },
    activities(state) {
      return state.activities;
    },

    treatmentsTotal(state) {
      let search = state.search;
      let result = 0;

      for (let gi = 0; gi < search.guests.length; gi++) {
        let guest = search.guests[gi];

        if (guest.treatments != null) {
          for (let ti = 0; ti < guest.treatments.length; ti++) {
            let treatment = guest.treatments[ti];

            result = result + treatment.duration.Price;
          }
        }
      }
      return result;
    },
    addOnsTotal(state) {
      let search = state.search;
      let result = 0;

      if (search?.groupAddOns != null) {
        for (let grpi = 0; grpi < search.groupAddOns.length; grpi++) {
          let gpa = search.groupAddOns[grpi];
          let selection = gpa.selection;
          let gpTotal = search.guests.length * selection.ActualPrice;
          result = result + gpTotal;
        }
      }

      if (search?.selectedTreatmentExtras != null) {
        for (let i = 0; i < search.selectedTreatmentExtras.length; i++) {
          let ex = search.selectedTreatmentExtras[i];
          let ets = ex.selection;

          let etot = ets.duration.Price;
          result = result + etot;
        }
      }

      if (search?.selectedMudExtras != null) {
        let ex2 = search.selectedMudExtras.selection.ActualPrice;

        result = result + ex2;
      }

      if (search?.selectedGardenExtras != null) {
        let ex3 = search.selectedGardenExtras.selection.ActualPrice;

        result = result + ex3 * search.selectedGardenExtras.guestIndexes.length;
      }

      return result;
    },
    extras(state) {
      let result = [];
      let search = state.search;

      for (let gi = 0; gi < search.guests.length; gi++) {
        let guest = search.guests[gi];

        if (guest.treatments != null) {
          for (let ti = 0; ti < guest.treatments.length; ti++) {
            let treatment = guest.treatments[ti];

            if (!treatment.duration.IsIncluded) {
              result.push(treatment);
            }
          }
        }
      }
      return result;
    },
    extrasTotal(state, getters) {
      var result = 0;

      result = getters.extras.reduce(function (i, item) {
        return i + item.duration.PriceDifference;
      }, 0);

      return result;
    },

    dayTotal(state) {
      let result = 0;
      let search = state.search;
      let guestCount = state.search.guests.length;

      let packagePrice = state.search.spaDay.bookingDetails.ActualPrice;

      result = guestCount * packagePrice;

      //We need to add in upsell costs here...

      for (let gi = 0; gi < search.guests.length; gi++) {
        let guest = search.guests[gi];

        if (guest.treatments != null) {
          for (let ti = 0; ti < guest.treatments.length; ti++) {
            let treatment = guest.treatments[ti];

            result = result + treatment.duration.PriceDifference;
          }
        }
      }

      if (search?.groupAddOns != null) {
        for (let grpi = 0; grpi < search.groupAddOns.length; grpi++) {
          let gpa = search.groupAddOns[grpi];
          let selection = gpa.selection;
          let gpTotal = search.guests.length * selection.ActualPrice;
          result = result + gpTotal;
        }
      }

      if (search?.selectedTreatmentExtras != null) {
        for (let i = 0; i < search.selectedTreatmentExtras.length; i++) {
          let ex = search.selectedTreatmentExtras[i];
          let ets = ex.selection;

          let etot = ets.duration.Price;
          result = result + etot;
        }
      }

      if (search?.selectedMudExtras != null) {
        let ex2 = search.selectedMudExtras.selection.ActualPrice;

        result = result + ex2;
      }

      if (search?.selectedGardenExtras != null) {
        let ex3 = search.selectedGardenExtras.selection.ActualPrice;

        result = result + ex3 * search.selectedGardenExtras.guestIndexes.length;
      }

      return result;
    },
    total(state) {
      let search = state.search;
      let result = 0;

      for (let gi = 0; gi < search.guests.length; gi++) {
        let guest = search.guests[gi];

        if (guest.treatments != null) {
          for (let ti = 0; ti < guest.treatments.length; ti++) {
            let treatment = guest.treatments[ti];

            result = result + treatment.duration.Price;
          }
        }
      }

      if (search?.groupAddOns != null) {
        for (let grpi = 0; grpi < search.groupAddOns.length; grpi++) {
          let gpa = search.groupAddOns[grpi];
          let selection = gpa.selection;
          let gpTotal = search.guests.length * selection.ActualPrice;
          result = result + gpTotal;
        }
      }

      if (search?.selectedTreatmentExtras != null) {
        for (let i = 0; i < search.selectedTreatmentExtras.length; i++) {
          let ex = search.selectedTreatmentExtras[i];
          let ets = ex.selection;

          let etot = ets.duration.Price;
          result = result + etot;
        }
      }

      if (search?.selectedMudExtras != null) {
        let ex2 = search.selectedMudExtras.selection.ActualPrice;

        result = result + ex2;
      }

      if (search?.selectedGardenExtras != null) {
        let ex3 = search.selectedGardenExtras.selection.ActualPrice;
        let ex3G = search.selectedGardenExtras.guestIndexes.length;

        result = result + ex3 * ex3G;
      }

      if (search?.selectedGardenExtras != null) {
        let ex3 = search.selectedGardenExtras.selection.ActualPrice;

        result = result + ex3 * search.selectedGardenExtras.guestIndexes.length;
      }

      return result;
    },
    guestName: (state) => (index) => {
      let result = "";

      let search = state.search;
      if (search.guests != undefined && search.guests != null && search.guests.length) {
        let guest = search.guests[index];

        result = guest.firstName;
      }

      return result;
    },
  },
  actions: {
    setGuestTimes(context, payload) {
      context.commit("setGuestTimes", payload);
    },
    setRestaurantTimes(context, payload) {
      context.commit("setRestaurantTimes", payload);
    },
    setSpaGardenTimes(context, payload) {
      context.commit("setSpaGardenTimes", payload);
    },
    removeAddOn(context, payload) {
      if (payload.addOn.content.SystemType == "GROUP") {
        context.commit("removeGroupAddOn", payload);
      } else {
        context.commit("removeAddOn", payload);
      }
    },
    selectAddOn(context, payload) {
      let item = {
        selectedKey: payload.addOn.availability[0].Key,
        selectedType: payload.addOn.content.SystemType,
        selection: payload.selection,
        content: payload.addOn.content,
      };

      if (item.selectedType == "GROUP") {
        context.commit("selectGroupAddOn", item);
      } else {
        context.commit("selectAddOn", item);
      }
    },

    setAccountStatus(context, payload) {
      context.commit("setAccountStatus", payload);
    },

    getConfiguration(context) {
      return new Promise((resolve) => {
        spaapi.getConfiguration((t) => {
          context.commit("setConfiguration", t);
          resolve(t);
        });
      });
    },
    createSession(context) {
      return new Promise((resolve) => {
        sessionapi.beginSpa((t) => {
          context.commit("setSession", t);
          resolve(t);
        });
      });
    },
    setSearch(context, payload) {
      return new Promise((resolve) => {
        context.commit("setSearch", payload);
        resolve();
      });
    },

    fetchGroupAvailability(context, payload) {
      return new Promise((resolve) => {
        spaapi.fetchGroupAvailability(payload, (t) => {
          resolve(t);
        });
      });
    },

    fetchAvailability(context, payload) {
      return new Promise((resolve) => {
        spaapi.getAvailability(payload.item, (t) => {
          context.commit("setAvailability", t);
          resolve(t);
        });
      });
    },

    fetchNakedAvailability(context, payload) {
      return new Promise((resolve) => {
        spaapi.getAvailability(payload, (t) => {
          resolve(t);
        });
      });
    },

    buildItinerary(context, payload) {
      return new Promise((resolve) => {
        spaapi.buildItinerary(payload.item, (t) => {
          context.commit("setAvailability", t);
          resolve(t);
        });
      });
    },

    fetchActivities(context, payload) {
      return new Promise((resolve, reject) => {
        spaapi.getActivities(payload.id, (t) => {
          context.commit("setActivities", t);
          resolve(t);
        });
      });
    },
    fetchPackages(context, payload) {
      return new Promise((resolve) => {
        spaapi.getPackages(payload.id, payload.item, (t) => {
          context.commit("setPackages", t.packages);

          context.commit("setFacilities", t.facilities);
          resolve(t);
        });
      });
    },

    clear(context) {
      return new Promise((resolve) => {
        context.commit("setSearch", null);

        context.commit("setAvailability", null);
        context.commit("setExtras", null);
        context.commit("setPackages", null);

        context.commit("setBooking", null);
        resolve();
      });
    },

    clearBooking(context) {
      return new Promise((resolve) => {
        context.commit("clearBooking");
        resolve();
      });
    },
    attachDetails(context, payload) {
      return new Promise((resolve) => {
        context.commit("setDetails", payload);
        resolve(payload);
      });
    },
    setGuests(context, payload) {
      return new Promise((resolve) => {
        context.commit("setGuests", payload);
        resolve(payload);
      });
    },
    setTreatment(context, payload) {
      return new Promise((resolve) => {
        context.commit("setTreatment", payload);
        resolve(payload);
      });
    },
    selectStartTime(context, payload) {
      return new Promise((resolve) => {
        context.commit("selectStartTime", payload);
        resolve(payload);
      });
    },

    selectTreatmentExtras(context, payload) {
      return new Promise((resolve) => {
        context.commit("selectTreatmentExtras", payload);
        resolve(payload);
      });
    },
    selectGardenExtras(context, payload) {
      return new Promise((resolve) => {
        context.commit("selectGardenExtras", payload);
        resolve(payload);
      });
    },

    selectMudExtras(context, payload) {
      return new Promise((resolve) => {
        context.commit("selectMudExtras", payload);
        resolve(payload);
      });
    },
    removeTreatment(context, payload) {
      return new Promise((resolve) => {
        context.commit("removeTreatment", payload);
        resolve(payload);
      });
    },

    setExtras(context, payload) {
      return new Promise((resolve) => {
        context.commit("setExtras", payload);
        resolve(payload);
      });
    },
    beginBooking(context, id) {
      let search = context.getters.search;

      let restaurantTime = null;
      if (search.restaurant != null) {
        restaurantTime = {
          restaurantId: search.restaurant.restaurantId,
          displayName: search.restaurant.displayName,
          facilityCode: search.restaurant.selectedTime.SpaCode,
          time: search.restaurant.selectedTime.TimeSlot,
          facilities: search.restaurant.selectedTime.Facilities,
        };
      }

      let selectedTreatmentExtras = [];
      if (search.selectedTreatmentExtras != null) {
        selectedTreatmentExtras = search.selectedTreatmentExtras;
      }

      let mudPackage = null;
      if (search.selectedMudExtras != null) {
        mudPackage = {
          clientIndex: 0,
          clientIndexes: search.selectedMudExtras.guestIndexes,
          itemType: 2,
          startDateTime: search.selectedMudExtras.selection.StartDateTime,
          endDateTime: search.selectedMudExtras.selection.EndDateTime,
          staffId: search.selectedMudExtras.selection.StaffID,
          roomId: search.selectedMudExtras.selection.RoomID,
          facilityId: search.selectedMudExtras.selection.FacilityID,

          appointmentTypeID: search.selectedMudExtras.selection.AppointmentTypeID,
          displayName: search.selectedMudExtras.addOn.content.DisplayName,
          duration: 60,
          code: search.selectedMudExtras.code.Code,
          price: search.selectedMudExtras.selection.ActualPrice,
        };
      }

      let spaGardenExtras = null;
      if (search?.selectedGardenExtras != null) {
        spaGardenExtras = [];
        for (var i in search.selectedGardenExtras.guestIndexes) {
          var item = search.selectedGardenExtras.guestIndexes[i];
          var spg = {
            isIncluded: false,
            guestIndex: item,
            selection: search.selectedGardenExtras.selection,
          };

          spaGardenExtras.push(spg);
        }
      }

      var payload = {
        specialRequest: search.details.requests,
        isSpaDay: search.spaDay != null,
        spaPackageName: search.spaDay?.DisplayName,
        date: search.date,
        leadGuestIndex: search.details.selectedGuest?.guestIndex,
        clients: search.guests.map(function (item) {
          return {
            title: item.title,
            firstName: item.firstName,
            lastName: item.lastName,
            arrivalTime: item.spaDayArrivalTime?.time,
            arrivalTimeFacility: item.spaDayArrivalTime?.selectedItem,
          };
        }),
        mudPackage: mudPackage,
        restaurantTime: restaurantTime,
        extraTreatments: selectedTreatmentExtras.map(function (item, index) {
          let treatmentTime = item.time.TreatmentTimes[0];

          return {
            clientIndex: item.guestIndex,
            itemType: treatmentTime.ItemType,
            startDateTime: treatmentTime.StartTime,
            endDateTime: treatmentTime.EndTime,
            staffId: treatmentTime.StaffId,
            roomId: treatmentTime.RoomId,
            facilityId: treatmentTime.FacilityId,

            appointmentTypeID: treatmentTime.AppointmentTypeID,
            displayName: item.selection.treatment.DisplayName,
            duration: item.selection.duration.Duration,
            code: item.selection.duration.Code,
            price: item.selection.duration.Price,
            isIncluded: false,
          };
        }),
        spaGardenExtraTimes: spaGardenExtras,
        spaGardenTimes: search.guests.map(function (item, index) {
          return {
            guestIndex: index,
            selection: item?.spaArrivalTime,
          };
        }),
        items: search.guests.flatMap(function (item) {
          let guestIndex = search.guests.indexOf(item);
          let startTime = item.startTime;

          //These here are selections if booked as part of a day, but are items if booked as a non day
          let result = [];
          if (item?.startTime?.TreatmentTimes != null && startTime.TreatmentTimes.length) {
            for (let i = 0; i < startTime.TreatmentTimes.length; i++) {
              let tt = startTime.TreatmentTimes[i];

              let treat = item.treatments.find((t) => t.duration.Id == tt.AppointmentTypeID);

              let innerI = {
                clientIndex: guestIndex,
                itemType: tt.ItemType,
                startDateTime: tt.StartTime,
                endDateTime: tt.EndTime,
                staffId: tt.StaffId,
                roomId: tt.RoomId,
                facilityId: tt.FacilityId,
                appointmentTypeID: tt.AppointmentTypeID,
                displayName: treat.treatment.DisplayName,
                duration: treat.duration.Duration,
                code: treat.duration.Code,
                price: treat.duration.Price,
                isIncluded: treat.duration.IsIncluded,
                priceDifference: treat.duration.PriceDifference,
              };

              result.push(innerI);
            }
          }

          return result;
        }),
      };

      if (payload.leadGuestIndex) {
        payload.clients[payload.leadGuestIndex].emailAddress = search.details.leadGuest.emailAddress;
        payload.clients[payload.leadGuestIndex].telephoneNumber = search.details.leadGuest.telephone;
        payload.clients[payload.leadGuestIndex].address1 = search.details.leadGuest.address?.line1;
        payload.clients[payload.leadGuestIndex].address2 = search.details.leadGuest.address?.line2;
        payload.clients[payload.leadGuestIndex].city = search.details.leadGuest.address?.city;
        payload.clients[payload.leadGuestIndex].country = search.details.leadGuest.address?.country;
        payload.clients[payload.leadGuestIndex].postCode = search.details.leadGuest.address?.postCode;
      }

      if (search.spaDayDetail?.Contents != null) {
        var diningId = search.spaDayDetail.Contents.find(
          (item) => item.SelectionItems != null && item.SelectionItems.filter((iitem) => iitem.AppointmentType.Category == "Dining").length
        )?.ItemID;

        var treatmentsId = search.spaDayDetail.Contents.find(
          (item) =>
            item.Description == "Selection" &&
            item.SelectionItems != null &&
            item.SelectionItems.filter((iitem) => iitem.AppointmentType.Category != "Dining").length
        )?.ItemID;

        payload.treatmentSelectionId = treatmentsId;
        payload.diningSelectionId = diningId;
      }

      if (search.spaDay?.bookingDetails != null) {
        payload.package = {
          packageId: search.spaDay?.bookingDetails.PackageID,
          displayName: search.spaDay?.DisplayName,
          price: search.spaDay?.bookingDetails.ActualPrice,
          endTime: search.spaDay.EndTime,
        };

        if (search.spaDay.bookingDetails.TimeBandIsRequired) {
          payload.package.packageTimeBandNumber = search.spaDay.bookingDetails.TimeBands[0].BandNumber;
        }
      }

      return new Promise((resolve, reject) => {
        spaapi.beginBooking(
          id,
          payload,
          (t) => {
            context.commit("bookingStarted", t);
            resolve(t);
          },
          (e) => {
            reject(e);
          }
        );
      });
    },
    confirmBooking(context, id) {
      return new Promise((resolve, reject) => {
        spaapi.processBooking(
          id,
          (t) => {
            context.commit("bookingConfirmed", t);
            resolve(t);
          },
          (e) => {
            reject(e);
          }
        );
      });
    },

    async validateFields(context, payload) {
      return new Promise((resolve, reject) => {
        spaapi.validateFields(
          payload,
          (t) => {
            resolve(t);
          },
          (t) => {
            reject({ error: t });
          }
        );
      });
    },
  },
  mutations: {
    setConfiguration(state, payload) {
      state.configuration = payload;
    },
    setSession(state, payload) {
      state.session = payload;
    },
    setSearch(state, payload) {
      state.search = payload;
    },

    setAvailability(state, payload) {
      state.availability = payload;
    },
    setExtras(state, payload) {
      state.extras = payload;
    },

    setActivities(state, payload) {
      state.activities = payload;
    },
    setPackages(state, payload) {
      state.packages = payload;
    },
    setFacilities(state, payload) {
      state.facilities = payload;
    },

    setBooking(state, payload) {
      state.booking = payload;
    },

    setGuests(state, payload) {
      if (state.search != null) {
        state.search.guests = payload.guests;
      }
    },
    setTreatment(state, payload) {
      if (state.search.guests != null) {
        let guest = state.search.guests[payload.guestIndex];
        if (guest != null) {
          if (guest.treatments == null) {
            guest.treatments = [];
          }

          guest.treatments.push(payload.selection);
        }
      }
    },
    removeTreatment(state, payload) {
      if (state.search.guests != null) {
        let guest = state.search.guests[payload.guestIndex];
        if (guest != null) {
          if (guest.treatments != null) {
            guest.treatments.pop(payload.selection);
          }
        }
      }
    },
    selectStartTime(state, payload) {
      if (state.search.guests != null) {
        let guest = state.search.guests[payload.guestIndex];
        if (guest != null) {
          guest.startTime = payload.selection;
          guest.restaurant = payload.restaurant;
          guest.spaGarden = payload.spaGarden;
        }
      }
    },

    setDetails(state, payload) {
      state.search.details = payload;
    },
    bookingStarted(state, payload) {
      console.log("booking started");
    },
    bookingConfirmed(state, payload) {
      console.log("booking confirmed");
    },
    setAccountStatus(state, payload) {
      state.session.accountCreateStatus = payload;
    },
    selectGroupAddOn(state, payload) {
      if (state.search.groupAddOns == null) {
        state.search.groupAddOns = [];
      }
      state.search.groupAddOns.push(payload);
    },
    selectAddOn(state, payload) {},

    removeGroupAddOn(state, payload) {
      let key = payload.addOn.content.Codes[0].PremierId;

      for (var i = 0; i < state.search.groupAddOns.length; i++) {
        let addOn = state.search.groupAddOns[i];

        if (addOn.selectedKey == key) {
          state.search.groupAddOns.splice(i, 1);
        }
      }
    },
    removeAddOn(state, payload) {},
    setGuestTimes(state, payload) {
      let guests = state.search.guests;
      for (let gi = 0; gi < payload.length; gi++) {
        guests[gi].spaDayArrivalTime = payload[gi].arrivalTime;
      }
    },
    setRestaurantTimes(state, payload) {
      state.search.restaurant = payload;
    },
    setSpaGardenTimes(state, payload) {
      let guests = state.search.guests;
      for (let gi = 0; gi < payload.length; gi++) {
        guests[gi].spaArrivalTime = payload[gi].spaArrivalTime;
      }
    },
    selectTreatmentExtras(state, payload) {
      state.search.selectedTreatmentExtras = payload;
    },
    selectMudExtras(state, payload) {
      state.search.selectedMudExtras = payload;
    },
    selectGardenExtras(state, payload) {
      state.search.selectedGardenExtras = payload;
    },
  },
});
